export const USE_API=true;

const dev = {
	API_ENDPOINT_URL: 'http://127.0.0.1:8000/api',
	X_API_KEY:'123456',
	WEB_URL:'http://127.0.0.1:8000',
	VERSION_APP:'2024.1.1',
    OAUTH_CLIENT_ID:'_c129685d34ab5ef8b761b11e3fc72c81a5176b5ff8',
    OAUTH_URL:'https://auth.um.ac.id/module.php/oidc/authorize.php',
    OAUTH_REDIRECT_URL:'http://localhost:3000/auth/callback',
};

const prod = {
	API_ENDPOINT_URL: 'https://servaniol.um.ac.id/api',
	X_API_KEY:'78ab0d2d-13a1-49d4-a23b-4be01fbe5853',
	WEB_URL:'https://servaniol.um.ac.id',
	VERSION_APP:'2025.1.1',
    OAUTH_CLIENT_ID:'_94102bdd90231e0036f2649a57eea47be34134d30d',
    OAUTH_URL:'https://auth.um.ac.id/module.php/oidc/authorize.php',
    OAUTH_REDIRECT_URL:'https://simfoni.um.ac.id/auth/callback',
};

const test = {
	API_ENDPOINT_URL: '/api'
};

const getEnv = () => {
	switch (process.env.NODE_ENV) {
		case 'development':
			return dev
		case 'production':
			return prod
		case 'test':
			return test
		default:
			break;
	}
}

export const env = getEnv()
